module.exports = __webpack_public_path__ + "489ab2cc7f4b7b46ab8385c4f7fafe96.svg";